import CashDrawer from "@/views/admin/printer/CashDrawers";

export default {
  path: "printers/cash-drawers",
  name: "cash-drawers",
  component: CashDrawer,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
